import { ChevronDownIcon, ChevronUpIcon, SquarePenIcon } from 'lucide-react';
import { useMemo } from 'react';

import { Service } from '../../../../../types/service.type';

import styles from './service-item.module.scss';

type Props = {
    service: Service;
    expanded: boolean;
    onEdit: (id: number) => void;
    onExpand: () => void;
};

const ServiceCardHeader = ({ service, expanded, onEdit, onExpand }: Props) => {
    const totalPlans: string = useMemo(() => {
        if (service.plans?.length === 1) return '1 plan';

        return `${service.plans?.length} planes`;
    }, [service.plans]);

    return (
        <div className={styles.header}>
            <div className={styles.headerInfo}>
                <h4>{service.name}</h4>
                <span className={styles.plansTag}>{totalPlans}</span>
            </div>
            <div className={styles.headerActions}>
                <div
                    className={styles.iconContainer}
                    onClick={() => onEdit(service.id)}
                >
                    <SquarePenIcon size={16} />
                </div>
                <div className={styles.iconContainer} onClick={onExpand}>
                    {expanded ? (
                        <ChevronUpIcon size={16} />
                    ) : (
                        <ChevronDownIcon size={16} />
                    )}
                </div>
            </div>
        </div>
    );
};

export { ServiceCardHeader };
